import {filterObject} from "~/lib/helpers/objects";
import {isDefined} from "~/lib/helpers/guards";
import {getNotificationContent} from "~/modules/notifications/service";
import {pick} from "~/lib/helpers";

export const NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES = 1000000;

export class Notification {

  public uuid: string = null;
  public title: string = null;
  public content: string = null;
  public hasContent: boolean = false;
  public description: string = null;
  public type: "feed" | "flash" = null;
  public publicationDate: string = null;
  public ownerUUID: string = null;

  static fromPayload(payload): Notification {
    let notification = new Notification(payload.ownerUUID);
    return Object.assign(notification, payload);
  }

  constructor(ownerUUID: string, type: "feed" | "flash" = "feed") {
    this.ownerUUID = ownerUUID;
    this.type = type;
  }

  isValid() {
    return isDefined(this.title) && isDefined(this.ownerUUID);
  }

  toJSON() {
    return filterObject(
      pick(this, ["title", "type", "ownerUUID", "content", "description", "publicationDate"]),
      (k, v) => {
        if( typeof v === "string") return v.length > 0;
        return isDefined(v)
      }
    );
  }

  async loadContent() {
    if (this.hasContent && !isDefined(this.content)) {
      this.content = await getNotificationContent(this);
    }
  }

  getContentSize() {
    return isDefined(this.content) ? byteCount(this.content) : 0;
  }

  isContentSizeValid() {
    return this.getContentSize() <= NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES;
  }

}

function byteCount(s) {
  return encodeURI(s).split(/%..|./).length - 1;
}